import { gql } from "@apollo/client";

export const PRICERS = gql`
  query Pricers(
    $where: PricerWhereInput
    $like: PricerWhereInput
    $take: Int
    $skip: Int
  ) {
    pricers(where: $where, take: $take, skip: $skip, like: $like) {
      data {
        id
        name
        type
        startDate
        endDate
        insurancePlan {
          id
          name
          risk
        }
        prices
        discount
        rules
        ageRule
      }
      count
    }
  }
`;

export const PRICER = gql`
  query Pricer($where: PricerWhereInput) {
    pricer(where: $where) {
      id
      name
      type
      startDate
      endDate
      insurancePlan {
        id
        name
        internal
        risk
      }
      prices
      discount
      rules
      ageRule
    }
  }
`;

const pricers = { PRICER, PRICERS };

export default pricers;
